export default __webpack_public_path__ + "static/media/gold-pieces.423149d7.svg";